import styled from 'styled-components';
import { rem } from 'polished';
import colors from '../../../../utils/colors';

const StyledCreateTransactionForm = styled.div`
	.score-submit {
		position: relative;
		min-height: ${rem('60px')};

		button {
			position: absolute;
			top: 0;
			right: ${rem('-73px')};
		}
	}

	.select-row {
		display: flex;
		flex-direction:row;
		justify-content:flex-start;
		align-items:center;

		label, input {
			display: flex;
			align-items:center;
		}

		label {
			color: ${colors.BRAND_RED};
			padding: 0.75rem 1rem 0.75rem 0;
		}
	}

	.icon {
		position: absolute;
		bottom: calc(50% - 12px);
		right: 15px;
		pointer-events: none;
	}

	.row-margin {
		margin-left: ${rem('4px')};
		margin-right: ${rem('4px')};
	}

	.quantity-input, .date-input {
		border-bottom: 1px solid ${colors.BRAND_RED};
		padding: 0.5rem 0 0 0;
		margin: 0 0 0.5rem 0;
		display: flex;

		input {
			border-color: ${colors.TRANSPARENT};
			margin 0;
		}
	}

	.secondary-select {
		flex: 1;
	}

	.quantity-input {
		flex: 2;
		margin-right: 2rem;
	}

	.date-input {
		flex: 3;
		padding-right: 3rem;
	}

	.primary-select, .secondary-select {
		margin-bottom: 0.5rem;
		position: relative;
	}

	.primary-select {
		border: 1px solid ${colors.GRAY_LIGHT};
		border-radius: 5px;
		min-height: ${rem('58px')};
		box-sizing: border-box;
		flex: 1;
		margin-bottom: 1rem;

		.brand {
			display: flex;
			flex: 2;
			justify-content:flex-start;
			padding-left: 1rem;
			margin-right: 1rem;
			font-family: FyranSans-Core;
			font-weight: bold;
			font-size: ${rem('22px')};
			color: ${colors.BRAND_RED};
		}

		.selected {
			display: flex;
			flex: 3;
			justify-content:flex-start;
			font-size: ${rem('16px')};
			color: ${colors.GRAY};
			padding-right: 3rem;
		}
	}

	.secondary-select {
		border-bottom: 1px solid ${colors.BRAND_RED};
	}

	.calendar {
		position: relative;
		width: 0;
		height: 0;
	}
`;

export default StyledCreateTransactionForm;


// WEBPACK FOOTER //
// ./src/modules/transaction/components/ui/StyledCreateTransactionForm.js